// extracted by mini-css-extract-plugin
export default {"text":"ReadMore_text__zTpiJ","cutted":"ReadMore_cutted__FG14Q","button":"ReadMore_button__yUimE"};